import { ReactNode } from 'react'

export const formatErrorMessages = (errorMessages: string[]): ReactNode => {
  return (
    <ul style={{ margin: 0 }}>
      {errorMessages.map((errorMessage, index) => (
        <li key={index}>{errorMessage}</li>
      ))}
    </ul>
  )
}
